<p>abstract-custom-input works!</p>
